import React  from 'react'
import { Alert, Panel, Form, Radio, FormGroup, Glyphicon } from 'react-bootstrap'
import classNames from 'classnames'

export default class LoggedOutDailyMenu extends React.Component
  constructor: (props) ->
    super(props)

    @state = { selectedGroup: props.menu.groupNames().first() }

  componentWillReceiveProps: (props) ->
    groupNames = props.menu.groupNames().toArray()

    @setState(selectedGroup: groupNames[0]) unless @state.selectedGroup in groupNames

  render: ->
    if @props.menu.hasMeals()
      <React.Fragment>{@props.menu.groupMenus().map(@groupPanel.bind(@))}</React.Fragment>
    else
      <Alert>Menu na tento den zatím není k dispozici</Alert>

  groupPanel: (groupMenu) ->
    isSelected = @state.selectedGroup == groupMenu.group.name

    <Panel bsStyle='info' key={groupMenu.group.name}
           className='group-menu' id={'group-menu-' + groupMenu.group.name}>
      {@groupPanelHeading(groupMenu, isSelected)}
      {@groupPanelBody(groupMenu) if isSelected}
    </Panel>

  groupPanelHeading: (groupMenu, isSelected) ->
    <Panel.Heading onClick={=> @setState(selectedGroup: groupMenu.group.name)}>
      <ul className='list-inline'>
        <li><Glyphicon glyph={if isSelected then 'chevron-down' else 'chevron-right'} /></li>
        <li><Panel.Title>{groupMenu.group.displayName}</Panel.Title></li>
      </ul>

      {@_additionalGroupPanelHeading(groupMenu)}
    </Panel.Heading>

  groupPanelBody: (groupMenu) ->
    { discriminatorHTML, discriminatorHeight } = groupMenu.canteen
    showDiscriminator = discriminatorHTML and discriminatorHeight and @_showDiscriminator()
    bodyProps         = {}

    if showDiscriminator
      minHeight  = groupMenu.canteen.discriminatorHeight or 0
      minHeight += 65 if @_hasAlert(groupMenu)

      bodyProps.style = { position: 'relative', minHeight: "#{minHeight}px" }

    <Panel.Body {...bodyProps}>
      {@groupMenu(groupMenu)}
      {@canteenDiscriminator(groupMenu) if showDiscriminator}
    </Panel.Body>

  _showDiscriminator: -> true

  canteenDiscriminator: (groupMenu) ->
    <p className={classNames('canteen-discriminator', 'hidden-xs', 'with-alert': @_hasAlert(groupMenu))}
       dangerouslySetInnerHTML={{__html: groupMenu.canteen.discriminatorHTML}} />

  _hasAlert: (groupMenu) -> false
  _additionalGroupPanelHeading: (groupMenu) ->

  groupMenu: (groupMenu) ->
    groupMenu.courseMenus().map (courseMenu) => @courseMenu(courseMenu, groupMenu)

  courseMenu: (courseMenu, groupMenu) ->
    <div key={courseMenu.course.name} className='course-menu'>
      {<h4>{courseMenu.course.displayName}</h4> if groupMenu.hasMoreThanOneCourse()}

      <ul>{courseMenu.meals.map (meal) => <li key={meal.number}>{meal.name}</li>}</ul>
    </div>
